<template>
	<div class="progressbar__container">
		<div
			:ref="refDoProgresso"
			class="progressbar__container__value"
		/>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
	name: 'ProgressBar',
	props: {
		/**
		 * Seta qual vai ser o id do componente
		 */
		id: {
			type: String,
			require: true,
		},
		/**
		 * Armazena o progresso atual
		 */
		progressoAtual: {
			type: Number,
			require: true,
		},
	},

	computed: {
		/**
		 * Id unico para a barra de progresso
		 */
		refDoProgresso() {
			return `ref_progress_bar_value_${uuidv4()}`
		},
	},
	mounted() {
		this.setarValorDoBalaoDoProgresso()
	},
	methods: {
		/**
		 * Seta qual o valor que deve ser exibido no balão da barra de progresso
		 */
		setarValorDoBalaoDoProgresso() {
			// Seta o valor do balão
			var elementoComValorDoProgresso = this.$refs[this.refDoProgresso]
			elementoComValorDoProgresso.setAttribute('valor-do-progresso', `${this.progressoAtual} %`)

			// Seta o plano de fundo
			var corDeFundo = ''
			if (this.progressoAtual < 33) corDeFundo = '--color-error-background'
			else if (this.progressoAtual < 66) corDeFundo = '--color-warning-background'
			else corDeFundo = '--color-green'
			elementoComValorDoProgresso.style.backgroundColor = `var(${corDeFundo})`

			// Anima o componente para o progresso
			setTimeout(() => {
				elementoComValorDoProgresso.style.width = `${this.progressoAtual}%`
			}, 100)
		},
	},
}
</script>

<style scoped>
.progressbar__container {
	height: 8px;
	min-width: 100px;
	background-color: #eee;
	border-radius: 100px;
	border: 1px solid #ddd;
}

.progressbar__container__value {
	height: 100%;
	width: 0%;
	background-color: rgb(var(--color-default));
	position: relative;
	border-radius: 100px;
	transition: width 1s ease;
}

.progressbar__container:hover > .progressbar__container__value::before {
	content: attr(valor-do-progresso);
	text-align: center;
	border-radius: 15px;
	position: absolute;
	font-size: 0.7rem;
	right: -25px;
	background-color: rgb(var(--color-primary));
	color: white;
	margin-top: -25px;
	min-width: 70px;
	font-weight: bold;
	z-index: 100;
}

.progressbar__container:hover > .progressbar__container__value::after {
	content: '';
	position: absolute;
	height: 0px;
	width: 0px;
	border: 8px solid transparent;
	border-bottom: 0;
	border-top: 8px solid rgb(var(--color-primary));
	right: -8px;
	margin-top: -10px;
}
</style>
